import type { TicketMeta, TripEvent } from '../types';
import { itinerary } from './itinerary';

export const ticketMeta: TicketMeta[] = [
  {
    eventId: 'ave03303', title: 'RENFE AVE 03303 · Madrid → Barcelona', date: '2026-10-29', city: 'Madrid → Barcelona', time: '10:27', count: 5,
    booking: 'DRKYUN / HKXJD9', access: 'Madrid Puerta de Atocha → Barcelona-Sants · llegada 13:44',
    requirements: ['5 boletos nominales con código de acceso', 'Asientos documentados 5/5', 'Coches 003 y 005', 'El acceso al tren cierra 2 minutos antes de la salida', 'Guardar los códigos disponibles offline'],
  },
  {
    eventId: 'sagrada', title: 'Sagrada Família', date: '2026-10-30', city: 'Barcelona', time: '11:00', count: 5,
    booking: '105315969', access: 'Acceso por Carrer de la Marina · visita guiada 11:45 · español',
    requirements: ['Entrada nominal', 'Llevar DNI o pasaporte', 'Presentarse con tiempo antes del acceso'],
  },
  {
    eventId: 'vatican', title: 'Museos Vaticanos', date: '2026-11-02', city: 'Roma / Vaticano', time: '08:30', count: 5,
    booking: '2L2NFLWZ19XTF1XAS', access: 'CORRIDOIO1 / PASSAGEWAY1 · entrada por Viale Vaticano',
    requirements: ['Mostrar boleto digital o impreso', 'Llevar identificación válida', 'Validar el boleto online antes de los torniquetes'],
  },
  {
    eventId: 'train-rm-fi', title: 'Frecciarossa 8418 · Roma → Florencia', date: '2026-11-03', city: 'Roma → Florencia', time: '11:35', count: 5,
    booking: 'UUMV25', access: 'Roma Termini → Firenze S. M. Novella · coche 4 · llegada 13:11',
    requirements: ['5 boletos individuales con código de acceso', 'Asientos 10C, 10D, 11B, 11C y 11D', 'Puede solicitarse identificación válida', 'Las puertas cierran 1 minuto antes de la salida', 'Guardar los códigos offline'],
  },
  {
    eventId: 'duomo', title: 'Cúpula de Brunelleschi', date: '2026-11-03', city: 'Florencia', time: '16:30', count: 5,
    booking: '87-HOZSL9E', access: 'Porta della Mandorla · horario fijo para la subida a la cúpula',
    requirements: ['463 escalones · sin elevador', 'Identificación requerida', 'Bolsas al depósito de equipaje', 'Brunelleschi Pass válido del 3 al 5 de noviembre'],
  },
  {
    eventId: 'train-fi-ve', title: 'Frecciarossa 9406 · Florencia → Venecia', date: '2026-11-05', city: 'Florencia → Venecia', time: '09:20', count: 5,
    booking: 'UUUU5N', access: 'Firenze S. M. Novella → Venezia S. Lucia · coche 4 · llegada 11:34',
    requirements: ['5 boletos individuales con código de acceso', 'Asientos 14C, 14D, 15B, 15C y 15D', 'Puede solicitarse identificación válida', 'Las puertas cierran 1 minuto antes de la salida', 'Proteger margen para San Marco 14:00'],
  },
  {
    eventId: 'san-marco', title: 'Basílica de San Marcos', date: '2026-11-05', city: 'Venecia', time: '14:00', count: 5,
    access: "Complete Experience: Basilica + Pala d'Oro + Museum + Loggia Cavalli · acceso 14:00–14:30",
    requirements: ['Llegar dentro de ±15 min', 'Hombros y rodillas cubiertos', 'No se admite equipaje mayor a 40×30×20 cm', 'Campanile no incluido'],
  },
  {
    eventId: 'louvre', title: 'Musée du Louvre', date: '2026-11-09', city: 'París', time: '09:00', count: 5,
    booking: 'C262350001803', access: 'Colecciones permanentes · Carrousel o Pirámide',
    requirements: ['Entradas nominativas y no transferibles', '5 reservas de audioguía', 'Audioguía: recoger bajo la Pirámide, planta -1'],
  },
  {
    eventId: 'versailles', title: 'Château de Versailles', date: '2026-11-10', city: 'Versalles', time: '10:00', count: 5,
    booking: 'Transaction 200229763', access: 'Billet Passeport · Entrada A · Pavillon Dufour',
    requirements: ['5 Billet Passeport con código de acceso', 'Objetivo de fila/control 09:40', 'Acceso dentro de la media hora del slot', 'Salir del dominio a primera hora de la tarde para proteger Orsay'],
  },
  {
    eventId: 'orsay', title: "Musée d'Orsay", date: '2026-11-10', city: 'París', time: '16:00', count: 5,
    access: 'Nueva fecha/hora confirmada para el itinerario',
    requirements: ['Nuevo comprobante pendiente de incorporar', 'No utilizar los vouchers antiguos fechados 09/10/2026', 'Mantener margen de regreso desde Versalles'],
    warning: '10-nov-2026 · 16:00 confirmado. Falta incorporar el nuevo PDF/QR al Wallet.',
  },
  {
    eventId: 'eurostar9023', title: 'Eurostar 9023 · París → Londres', date: '2026-11-11', city: 'París → Londres', time: '11:02', count: 5,
    booking: 'GJ22VG', access: 'Paris Gare du Nord → London St Pancras International · coche 11 · llegada 12:30',
    requirements: ['5 boletos individuales con código para torniquetes', 'Presentarse en Eurostar departures a las 10:02', 'Las puertas cierran 30 minutos antes de la salida', 'Pasaporte y documentos de viaje listos para control fronterizo', 'Guardar los códigos offline'],
  },
  {
    eventId: 'british-museum', title: 'British Museum', date: '2026-11-12', city: 'Londres', time: '10:00', count: 5,
    booking: '10921787', access: 'General admission',
    requirements: ['Llevar e-ticket digital o impreso', 'Llegar a la hora reservada', 'No llevar maletas con ruedas ni equipaje grande'],
  },
  {
    eventId: 'nhm', title: 'Natural History Museum', date: '2026-11-13', city: 'Londres', time: '10:00', count: 5,
    booking: '7792724', access: 'South Kensington · Cromwell Road, London SW7 5BD',
    requirements: ['4 entradas Adult - Free', '1 entrada Child - Free', 'Guardar los códigos disponibles offline'],
  },
];

export const ticketMetaByEvent = Object.fromEntries(ticketMeta.map((item) => [item.eventId, item])) as Record<string, TicketMeta>;

const trainEventUpdates: Record<string, Partial<TripEvent>> = {
  'train-rm-fi': {
    confirmation: 'UUMV25',
    details: ['Frecciarossa 8418 · 2° Premium · coche 4', '5 pasajeros · asientos confirmados 5/5', 'Puede solicitarse identificación válida', 'Las puertas del tren cierran 1 minuto antes de la salida', 'Llegada 13:11 · proteger margen para equipaje y Cúpula 16:30'],
    passengers: [
      { travelerId: 'ricardo', name: 'Ricardo Francisco Alberto Reig Vélez', coach: '4', seat: '11C', booking: 'UUMV25' },
      { travelerId: 'aurora', name: 'Aurora Vilchis Marín', coach: '4', seat: '11B', booking: 'UUMV25' },
      { travelerId: 'arturo', name: 'Arturo Reig Muro Sandoval', coach: '4', seat: '11D', booking: 'UUMV25' },
      { travelerId: 'ileana', name: 'Ileana Mendoza Ávila', coach: '4', seat: '10D', booking: 'UUMV25' },
      { travelerId: 'arturo-jr', name: 'Arturo Reig Mendoza', coach: '4', seat: '10C', booking: 'UUMV25' },
    ],
  },
  'train-fi-ve': {
    confirmation: 'UUUU5N',
    details: ['Frecciarossa 9406 · 2° Premium · coche 4', '5 pasajeros · asientos confirmados 5/5', 'Puede solicitarse identificación válida', 'Las puertas del tren cierran 1 minuto antes de la salida', 'Llegada 11:34 · proteger margen para San Marco 14:00'],
    passengers: [
      { travelerId: 'ricardo', name: 'Ricardo Francisco Alberto Reig Vélez', coach: '4', seat: '15C', booking: 'UUUU5N' },
      { travelerId: 'aurora', name: 'Aurora Vilchis Marín', coach: '4', seat: '15B', booking: 'UUUU5N' },
      { travelerId: 'arturo', name: 'Arturo Reig Muro Sandoval', coach: '4', seat: '14C', booking: 'UUUU5N' },
      { travelerId: 'ileana', name: 'Ileana Mendoza Ávila', coach: '4', seat: '15D', booking: 'UUUU5N' },
      { travelerId: 'arturo-jr', name: 'Arturo Reig Mendoza', coach: '4', seat: '14D', booking: 'UUUU5N' },
    ],
  },
};

// Enlaza automáticamente cada actividad con su bloque correspondiente del Wallet
// y completa los nuevos datos ferroviarios documentados en los boletos originales.
const ticketAliases: Record<string, string> = {
  'florence-pass': 'duomo',
};

for (const day of itinerary) {
  for (const event of day.events) {
    const trainUpdate = trainEventUpdates[event.id];
    if (trainUpdate) Object.assign(event, trainUpdate);
    if (event.ticketEventId) continue;
    const target = ticketAliases[event.id] ?? event.id;
    if (ticketMetaByEvent[target]) event.ticketEventId = target;
  }
}
